import { forwardRef } from "react"

import * as SliderPrimitive from "@radix-ui/react-slider"

export type SliderProps = SliderPrimitive.SliderProps

export const Slider = forwardRef<HTMLSpanElement, SliderPrimitive.SliderProps>(
  function Slider(props, forwardedRef) {
    const value = props.value || props.defaultValue

    return (
      <SliderPrimitive.Slider
        {...props}
        ref={forwardedRef}
        className="relative flex h-4 touch-none items-center select-none"
      >
        <SliderPrimitive.Track className="relative h-1 grow bg-colors-border-secondary">
          <SliderPrimitive.Range className="absolute h-full bg-colors-icon-brand" />
        </SliderPrimitive.Track>
        {value?.map((_, i) => (
          <SliderPrimitive.Thumb
            key={i}
            className="focus-outline block h-3 w-3 rounded-full bg-colors-icon-brand"
          />
        ))}
      </SliderPrimitive.Slider>
    )
  },
)
